import {useMemo} from "react";
import Table from "@mui/material/Table";
import { Paper, TableContainer, IconButton, Typography, Select, MenuItem } from "@mui/material";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import "./Invoice.css"
import { ColumnNames } from "./InvoiceColumnNames";
import moment from "moment";




function Invoices ({ data, handleDelete})
{
    const columns = useMemo(() => ColumnNames, []);
    if (data === undefined)
        data = []
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        setPageSize,
        pageOptions,
        state,
        prepareRow,
    } = useTable(
        {
        columns,
        data, 
        initialState: {
            pageSize: 5,
            hiddenColumns: ['id']
        },
        },
        useGlobalFilter,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    );

    const {pageIndex, pageSize } = state;
    


        return (
            <div>
                <div className="display-container">
                    <Typography align='center' variant="h4" component="div" gutterBottom>
                        Invoices
                    </Typography>
                        
                    <TableContainer key = {"Table"} sx={{marginTop: 1}} component={Paper}>
                        <Table {...getTableProps()}>
                        <TableHead>
                            {headerGroups.map((headerGroup, i) => (
                            <TableRow key={i} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                <TableCell align="center"
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                >
                                    {column.render("Header")}
                                </TableCell>
                                ))}
                            </TableRow>
                            ))}
                        </TableHead>
                        <TableBody {...getTableBodyProps()}>
                            {page.map((row) => {
                            prepareRow(row);
                            return (
                                <TableRow {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                    if (cell.column.id === 'delete')
                                    {
                                        const invoice_rateJSON = {billing_frequency: row.cells[0].value,
                                                            billing_type: row.cells[1].value,
                                                            invoice_effective_date: row.cells[3].value,
                                                            po_number: row.cells[4].value}
                                        return (
                                            <TableCell>
                                                <IconButton sx={{ marginLeft: 5 }} onClick={(e) => {e.preventDefault(); handleDelete(invoice_rateJSON)}}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        )
                                    }
                                    else
                                    {
                                        if (moment.isMoment(cell.value))
                                            return (
                                                <TableCell align ={'center'} {...cell.getCellProps()}>
                                                    <Typography>{cell.value.format("MM/DD/YYYY")}</Typography>
                                                </TableCell>
                                            )
                                        else
                                            return (
                                                <TableCell align ={'center'} {...cell.getCellProps()}>
                                                    <Typography>{cell.render("Cell")}</Typography>
                                                </TableCell>
                                        );
                                    }
                                })}
                                </TableRow>
                            );
                            })}
                        </TableBody>
                        </Table>
                        <div className="pagination">
                        <span className="page-selector">
                            <Typography sx={{fontSize: '0.875rem'}}>Rows Per Page:</Typography>
                            <Select
                            sx={{marginRight: '24px', marginLeft: '8px', fontSize: '0.875rem'}}
                            disableUnderline
                            variant="standard"
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            >
                            {[10, 15, 25, 50].map((pageSize) => (
                                <MenuItem key={pageSize} value={pageSize}>
                                {pageSize}
                                </MenuItem>
                            ))}
                            </Select>
                            <Typography sx={{fontSize: '0.875rem', marginRight:'24px'}}>
                            {pageIndex + 1} of {pageOptions.length}
                            </Typography>{" "}
                        </span>
                        <IconButton onClick={() => previousPage()} disabled={!canPreviousPage}>
                        <ChevronLeftIcon/>
                        </IconButton>
                        <IconButton onClick={() => nextPage()} disabled={!canNextPage}>
                        <ChevronRightIcon/>
                        </IconButton>
                        </div>
                    </TableContainer>
                    </div>
            </div>
        )
}



export default Invoices